<template>
  <div class="card shadow-sm spec-card mb-4">
    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap: 8px;">
        <h6 class="mb-0 font-weight-bold"><i class="fe fe-award mr-1"></i>{{ title }}</h6>
        <button v-if="editable && !editing" type="button" class="btn btn-sm btn-outline-primary" @click="startEdit">
          <i class="fe fe-edit-2 mr-1"></i>Edit
        </button>
      </div>

      <div v-if="!editing" class="mt-2">
        <span v-for="s in current" :key="s.id" class="spec-chip">{{ s.name }}</span>
        <span v-if="!current.length" class="small text-muted">No specializations recorded.</span>
      </div>

      <form v-else class="mt-2" @submit.prevent="save">
        <label :for="inputId" class="sr-only">Specializations</label>
        <v-select v-model="selected" :input-id="inputId" :options="options" label="name" :reduce="s => s.id" multiple
          placeholder="Search specializations…">
          <template #option="option">
            {{ option.name }} <span class="text-muted small">· {{ option.category }}</span>
          </template>
        </v-select>
        <div class="d-flex mt-2" style="gap: 6px;">
          <button type="submit" class="btn btn-sm btn-primary" :disabled="saving">Save</button>
          <button type="button" class="btn btn-sm btn-light" @click="editing = false">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// Specializations of a facility or doctor (users.id). Saving needs the user themselves, their facility,
// or agency staff of a linked agency; the API answers 403 otherwise.
export default {
  name: "SpecializationsCard",
  props: {
    userId: { type: [Number, String], required: true },
    editable: { type: Boolean, default: false },
    title: { type: String, default: "Specializations" },
  },
  data() {
    return { current: [], options: [], selected: [], editing: false, saving: false };
  },
  computed: {
    inputId() {
      return "spec-input-" + this.userId;
    },
  },
  watch: {
    userId() {
      this.load();
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      if (!this.userId) return;
      this.axios.get(`/api/v1/auth/specializations/user/${this.userId}`).then((res) => (this.current = res.data.data || []));
    },
    startEdit() {
      this.selected = this.current.map((s) => s.id);
      this.editing = true;
      if (!this.options.length) {
        this.axios.get("/api/v1/specializations").then((res) => (this.options = res.data.data || []));
      }
    },
    save() {
      this.saving = true;
      this.axios
        .put(`/api/v1/auth/specializations/user/${this.userId}`, { specialization_ids: this.selected })
        .then((res) => {
          this.current = res.data.data || [];
          this.editing = false;
          this.$emit("saved", this.current);
        })
        .catch((err) => {
          const msg = (err.response && err.response.data && err.response.data.message) || "Could not save the specializations";
          this.$toasted.error(msg, { position: "top-center", duration: 4000 });
        })
        .finally(() => (this.saving = false));
    },
  },
};
</script>

<style scoped>
.spec-card { border-radius: 12px; border: none; }
.spec-chip { display: inline-block; background: #ede9fe; color: #5b21b6; border-radius: 20px; padding: 3px 10px; font-size: .78rem; font-weight: 600; margin: 0 6px 6px 0; }
</style>
